/**
 * @generated SignedSource<<2afbe811ddea704ac95e08313c234d94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditPipelinePageApplySecretQuery$variables = {
  input: string;
  projectLocator: string;
};
export type EditPipelinePageApplySecretQuery$data = {
  readonly addSecureToken: string | null | undefined;
};
export type EditPipelinePageApplySecretQuery = {
  response: EditPipelinePageApplySecretQuery$data;
  variables: EditPipelinePageApplySecretQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectLocator"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "projectLocator",
        "variableName": "projectLocator"
      }
    ],
    "kind": "ScalarField",
    "name": "addSecureToken",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPipelinePageApplySecretQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditPipelinePageApplySecretQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "19eb3be0d580f286b25f383cd96158cb",
    "id": null,
    "metadata": {},
    "name": "EditPipelinePageApplySecretQuery",
    "operationKind": "query",
    "text": "query EditPipelinePageApplySecretQuery(\n  $projectLocator: String!\n  $input: String!\n) {\n  addSecureToken(projectLocator: $projectLocator, input: $input)\n}\n"
  }
};
})();

(node as any).hash = "b4034a73c863e286addd7e6f3eee7f17";

export default node;
